import React from 'react'
import {OWNERSHIP_NOTE, SHARED_FOLDERS_MANUAL_URL} from './constants'

interface OwnershipNoteProps {
  /** `callout` for the moment of sharing; `plain` inside the "About ownership" section. */
  variant?: 'callout' | 'plain'
}

/** What owning a shared folder means (D11), with a link to the manual's "Choosing the owner". */
export const OwnershipNote: React.FC<OwnershipNoteProps> = ({variant = 'callout'}) => {
  const body = (
    <>
      {OWNERSHIP_NOTE.map((sentence) => (
        <p key={sentence} className='mb-2'>
          {sentence}
        </p>
      ))}
      <a href={SHARED_FOLDERS_MANUAL_URL} target='_blank' rel='noreferrer' className='fw-semibold'>
        Choosing the owner of a shared folder
        <i className='fas fa-arrow-up-right-from-square ms-1 fs-8' aria-hidden='true' />
      </a>
    </>
  )
  if (variant === 'plain') {
    return (
      <div className='ob-sharing-ownership' data-testid='sharing-ownership-note'>
        {body}
      </div>
    )
  }
  return (
    <div
      className='alert alert-info ob-sharing-ownership mb-0'
      role='note'
      data-testid='sharing-ownership-note'
    >
      <div className='d-flex gap-3'>
        <i className='fas fa-circle-info mt-1' aria-hidden='true' />
        <div>{body}</div>
      </div>
    </div>
  )
}
